import { Droplet, Fan, Fuel, PlaneLanding, PlaneTakeoff, Play, Power, Square, type LucideIcon } from "lucide-react";

/**
 * How each mission event looks, taken from the app's own
 * `MissionEvent.buttonColor` and SF Symbol annotations: takeoff and landing
 * are orange, drops yellow, refuelling and the engine red, start and end grey.
 *
 * Matching them means the colour an ops manager reads in the log is the colour
 * of the button the pilot pressed.
 */
type EventStyle = { icon: LucideIcon; tint: string };

const TINT = {
  orange: "bg-accent/20 text-accent-text",
  yellow: "bg-drop/20 text-drop",
  red: "bg-danger/15 text-danger",
  gray: "bg-muted/15 text-ink-soft",
} as const;

const STYLES: Record<string, EventStyle> = {
  start: { icon: Play, tint: TINT.gray },
  engineStarted: { icon: Fan, tint: TINT.red },
  takeoff: { icon: PlaneTakeoff, tint: TINT.orange },
  drop: { icon: Droplet, tint: TINT.yellow },
  reFuel: { icon: Fuel, tint: TINT.red },
  landed: { icon: PlaneLanding, tint: TINT.orange },
  engineShutdown: { icon: Power, tint: TINT.red },
  end: { icon: Square, tint: TINT.gray },
};

export function EventBadge({ event }: { event: string }) {
  const style = STYLES[event] ?? { icon: Square, tint: TINT.gray };
  const Icon = style.icon;
  return (
    <span className={`grid place-items-center w-8 h-8 rounded-lg shrink-0 ${style.tint}`} aria-hidden>
      <Icon size={17} strokeWidth={2.3} />
    </span>
  );
}
